/**
 * Google Tag Manager, Lucky Orange and PostHog, started only once a visitor agrees.
 *
 * Tag Manager carries Google Analytics and the Meta Pixel, so it is the gate
 * for both. Each runs only where the server gives it an identifier, which is
 * the live site alone, so testing never reaches the live figures.
 */
let posthog = null
let started = false
let identifiedUser = null
let posthogIdentified = false

function scriptAdd(src) {
  const script = document.createElement('script')
  script.async = true
  script.src = src

  // Note: Tag Manager passes the page's nonce on to its own tags, as its standard snippet does
  const nonce = document.querySelector('script[nonce]')?.nonce
  if (nonce) {
    script.setAttribute('nonce', nonce)
  }
  document.head.appendChild(script)
}

export function trackersStart(trackers) {
  if (started) {
    return
  }
  started = true

  if (trackers.google_tag_manager_id) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })
    scriptAdd(`https://www.googletagmanager.com/gtm.js?id=${trackers.google_tag_manager_id}`)
  }
  if (trackers.lucky_orange_site_id) {
    scriptAdd(`https://tools.luckyorange.com/core/lo.js?site-id=${trackers.lucky_orange_site_id}`)
  }
  if (trackers.posthog) {
    posthogStart(trackers.posthog)
  }
}

// Note: fetched only once a visitor agrees, so nobody who refuses downloads it
async function posthogStart(posthogConfig) {
  const client = (await import('posthog-js')).default

  client.init(posthogConfig.key, {
    api_host: posthogConfig.host,
    capture_pageview: 'history_change',
    person_profiles: 'identified_only',
    session_recording: { maskAllInputs: true },
  })
  posthog = client
  posthogIdentify(identifiedUser)
}

function posthogIdentify(user) {
  if (!posthog) {
    return
  }
  if (user) {
    posthog.identify(String(user.id), { user_type: user.user_type })
    posthogIdentified = true
  } else if (posthogIdentified) {
    // Note: signing out starts a new anonymous visitor, so the next person on the device is not merged in
    posthog.reset()
    posthogIdentified = false
  }
}

export function trackersIdentify(user) {
  identifiedUser = user ?? null
  posthogIdentify(identifiedUser)
}

export function trackersCapture(event, params) {
  posthog?.capture(event, params)
}
